import { Component, ViewChild, ElementRef } from '@angular/core';
import { Platform, NavController} from '@ionic/angular';
import { ResultProvider } from '../../../providers/result/result';
import { DeviceMotion, DeviceMotionAccelerationData } from '@awesome-cordova-plugins/device-motion/ngx';;
import { AudioSystemProvider } from '../../../providers/audio-system/audio-system';
import { TranslateService } from '@ngx-translate/core';
import { UserProvider } from '../../../providers/user/user';
import { Storage } from '@ionic/storage';
import { StrackerProvider, TrackerModel } from '../../../providers/stracker/stracker';
import { SessionProvider } from '../../../providers/session/session';
import { Device } from '@awesome-cordova-plugins/device/ngx';
import { Diagnostic } from '@awesome-cordova-plugins/diagnostic/ngx';
import { ConfigProvider } from '../../../providers/config/config';
import { AndroidPermissions } from '@awesome-cordova-plugins/android-permissions/ngx';//'@ionic-native/android-permissions/ngx';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

declare var google;

/**
 * THIS COMPONENT IS DEPRECATED AND HAS TO BE REMOVED.
 */

@Component({
    selector: 'permission-page',
    templateUrl: 'permission.html',
})
export class PermissionPage {

    appName: string = "";
    appLogo: string = "";
    background: string = "";
    os: string = "";
    routerState:any;

    constructor(
        public platform: Platform,
        private router:Router,
        private config: ConfigProvider,
        private androidPermissions: AndroidPermissions,
        private nav: NavController,
        private location:Location
    ) {
            const navParam = this.router.getCurrentNavigation();
            this.routerState = navParam?.extras?.state || {};
            this.os = this.routerState['os'];
    }

    doneIOS() {
        // (this.app.getRootNav() as NavController).pop();
        this.location.back();
    }

    doneANDROID() {
        this.checkBackgroundPermission();
        this.location.back();
        // (this.app.getRootNav() as NavController).pop();
    }

    cancel() {
        this.nav.pop().then(() => this.nav.pop());
    }

    async ionViewDidEnter() {
        this.appName = (await this.config.config).appId;
        this.appLogo = "/assets/imgs/tutorial/" + this.appName + ".png";
        this.background = "background: url('" + this.appLogo + "') 50% 0 / 90px repeat;"
        document.getElementsByClassName('pattern-bg').item(0).setAttribute('style', this.background);
        document.getElementsByClassName('pattern-bg').item(1).setAttribute('style', this.background);

        console.log('this.background: ', this.background);
    }

    private async checkBackgroundPermission() {
        try {
            console.log('this.androidPermissions.PERMISSION.ACCESS_FINE_LOCATION: ', this.androidPermissions.PERMISSION.ACCESS_BACKGROUND_LOCATION);
            const result = await this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.ACCESS_BACKGROUND_LOCATION);
            if (!result || result.hasPermission === false) {
                this.requestPermissions();
            }
        } catch (error) {
            this.requestPermissions();
        }
    }

    private async requestPermissions() {
        try {
            console.log('this.androidPermissions.PERMISSION.ACCESS_BACKGROUND_LOCATION: ', this.androidPermissions.PERMISSION.ACCESS_BACKGROUND_LOCATION);
            const data = await this.androidPermissions.requestPermissions([
                this.androidPermissions.PERMISSION.ACCESS_BACKGROUND_LOCATION,
                this.androidPermissions.PERMISSION.ACCESS_COARSE_LOCATION,
                this.androidPermissions.PERMISSION.ACCESS_FINE_LOCATION,
                this.androidPermissions.PERMISSION.ACTIVITY_RECOGNITION,
                this.androidPermissions.PERMISSION.FOREGROUND_SERVICE
            ]);
            if (!data.hasPermission) {
                throw new Error('No permission');
            }
        } catch (error) {
            console.log('We need background location access in order to continue.');

        }
    }
}


